import { observable, action } from "mobx";
import axios from "../AxiosInstance";
import { ApiUrl } from "../helpers";

const copyDefaultTemplatesStore = observable(
  {
    isSubmitting: false,
    lastResult: null,
    lastError: null,

    setLastResult(result) {
      this.lastResult = result;
    },

    setLastError(message) {
      this.lastError = message;
    },

    reset() {
      this.lastResult = null;
      this.lastError = null;
    },

    async copyDefaultTemplates({ targetCompanyIds }) {
      this.isSubmitting = true;
      this.lastError = null;
      try {
        const response = await axios.post(ApiUrl.copyDefaultTemplates, {
          targetCompanyIds,
        });
        const data = response?.data ?? {};
        // The API wraps business failures as HTTP 200 with a non-200 body statusCode
        // (AutoWrapper + `return Ok(result)`), so axios does not reject. A failed copy
        // (e.g. "Default template source company is not configured", 500) must be detected
        // from the body statusCode like the other stores do, otherwise the caller wrongly
        // reports success.
        if (data.statusCode && data.statusCode >= 400) {
          throw new Error(data.message || "Failed to copy templates");
        }
        const result = data.result ?? null;
        action(() => {
          this.lastResult = result;
        })();
        return result;
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          "Failed to copy templates";
        action(() => {
          this.lastError = message;
        })();
        throw err;
      } finally {
        action(() => {
          this.isSubmitting = false;
        })();
      }
    },
  },
  {
    setLastResult: action,
    setLastError: action,
    reset: action,
    copyDefaultTemplates: action,
  }
);

export default copyDefaultTemplatesStore;
